// @flow
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import Error from 'components/Error'
import { getAccount } from 'lib/account/selectors'
import { isAuditor, getUserRoles } from 'lib/user/selectors'
import { clearAccount, fetchAccountHTTP } from 'lib/account/actions'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import type { Account } from 'lib/types'
import { Template } from './Template'
import { httpPut } from 'lib/http'
import { withRouter } from 'lib/hooks/withRouter'

type Props = {
  account: Account,
  dispatch: Function,
  isAuditor: boolean,
  userRoles: Array<string>,
  location: Object,
}

class Number extends React.Component {
  props: Props

  constructor(props) {
    super(props)
    this.state = {
      error: null,
      showStatusDialog: false,
    }
  }

  loadAccount(number) {
    const { dispatch } = this.props
    dispatch(setLoad())
    dispatch(fetchAccountHTTP(number))
      .then(() => this.setState({ error: false }))
      .catch((error) => {
        if (error.code === 404) {
          this.setState({ error: true })
        } else {
          throw error
        }
      })
      .then(() => dispatch(setUnload()))
  }

  showAccountStatusDialog = () => {
    this.setState({ showStatusDialog: true })
  }

  hideAccountStatusDialog = () => {
    this.setState({ showStatusDialog: false })
  }

  handleStatusChange = async (newStatus) => {
    const { dispatch, account } = this.props

    if (!newStatus) {
      return
    }

    try {
      await httpPut(`/admin/accounts/${account.number}/status`, {
        status: newStatus,
      })

      dispatch(setBanner('Account status updated successfully', 'success'))
      this.setState({ showStatusDialog: false })

      window.location.reload(false)
    } catch (error) {
      const errorMessage = error.errors ? error.errors.join(', ') : error.message || 'Failed to update account status'
      dispatch(setBanner(errorMessage, 'danger'))
      this.setState({ showStatusDialog: false })
    }
  }

  componentWillUnmount() {
    this.props.dispatch(clearAccount())
  }

  componentDidMount() {
    this.loadAccount(this.props.location.params.number)
  }

  componentDidUpdate(prevProps) {
    const { number } = this.props.location.params
    if (prevProps.location.params.number !== number) {
      this.loadAccount(number)
    }
  }

  render() {
    const { account, dispatch, isAuditor, userRoles } = this.props
    const { showStatusDialog } = this.state

    if (this.state.error) {
      return <Error title="404: Account Not Found" message="The account you are looking for does not exist" icon="account" />
    }

    if (this.state.error === false) {
      return (
        <Template
          account={account}
          dispatch={dispatch}
          isAuditor={isAuditor}
          userRoles={userRoles}
          showAccountStatusDialog={this.showAccountStatusDialog}
          hideAccountStatusDialog={this.hideAccountStatusDialog}
          handleStatusChange={this.handleStatusChange}
          showStatusDialog={showStatusDialog}
        />
      )
    }
    return null
  }
}

export default withRouter(
  connect(
    createStructuredSelector({
      account: getAccount,
      isAuditor,
      userRoles: getUserRoles,
    }),
  )(Number),
)
